import React, { Component } from 'react';
import {
  withRouter
} from 'react-router-dom';
import {
  reqUserAuthInstall
} from "../../../api";
import SkeltonSpinnerLoading from '../../../components/SkeltonSpinnerLoading';

class install extends Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    window.SEOAntHost = params.get("host");
    this.UserAuthInstall(params);
  }

  // 重新渲染页面
  handleTabChange = (historyUrl) => {
    const { history } = this.props;
    history.push(historyUrl);
  };

  //获取当前抓取状态
  UserAuthInstall = async (par) => {
    const params = {
      'shop': par.get("shop"),
      'hmac': par.get("hmac"),
      'host': par.get("host"),
      'locale': par.get("locale"),
      'session': par.get("session"),
      'timestamp': par.get("timestamp"),
    };

    const response = await reqUserAuthInstall(params);
    if (response.code === 301) {
      window.location.href = response.url;
      // console.log('history301', response.url);
    }else if (response.code === 200) {
      this.handleTabChange(response.data.redirection_url);
    }else{
      console.log('error');
    }
  }

  render() {
    return (
      <SkeltonSpinnerLoading />
    )
  }
}

export default withRouter(install);